
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class LoadingScreen extends Vue {
  @Prop({ default: true }) readonly isLoading!: boolean
}
